export function filterParticipants(rows, { query = '', activityId = '', status = '' } = {}) {
  const needle = String(query).trim().toLowerCase();
  return rows.filter((row) => {
    const haystack = [row.nome, row.email, row.identificador].filter(Boolean).join(' ').toLowerCase();
    if (needle && !haystack.includes(needle)) return false;
    if (activityId) {
      const enrolled = (row.activities || []).some(
        (activity) => String(activity.id) === String(activityId) && activity.status === 'active'
      );
      if (!enrolled) return false;
    }
    if (status === 'active' || status === 'cancelled') return row.enrollmentStatus === status;
    if (status === 'present') return Boolean(row.checkInAt);
    if (status === 'absent') return !row.checkInAt && (row.enrollmentStatus === 'active' || Boolean(row.checkOutAt));
    if (status === 'checked_out') return Boolean(row.checkOutAt);
    return true;
  });
}
